module.exports = __webpack_public_path__ + "static/img/SPICE-AND-HERB.c8f02c64.jpg";